<div class="modal-header">
  <h4 class="modal-title pull-left">
    Add carrier
  </h4>

  <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
  </button>
</div>

<div class="modal-body">
  <form class="form-horizontal" #newCarrierForm="ngForm">
    <div class="form-group">
      <label for="name" class="col-sm-3 control-label">Carrier name</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" id="name" name="name" [(ngModel)]="carrier.name" #name="ngModel" required>
        <div class="form-error" [hidden]="name.valid || name.untouched">
          @if (name.errors?.required) {
            <p>This field is required.</p>
          }
        </div>
        @if (name.errors?.serverError) {
          <div class="form-error">
            <p>{{ name.errors.serverError }}</p>
          </div>
        }
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>
  <button type="button" class="btn btn-primary" [disabled]="!newCarrierForm.form.valid" (click)="save()">Save</button>
</div>
